import { render, staticRenderFns } from "./Mypagebookmark.vue?vue&type=template&id=7441034a&"
import script from "./Mypagebookmark.vue?vue&type=script&lang=ts&"
export * from "./Mypagebookmark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports